import { useEffect } from 'react';
import * as api from 'app/api';

export default function LoginPage() {
  useEffect(() => {
    window.location.href = api.getLoginUrl();
  }, []);
  return null;
}
